import React from "react";
import { GetContent } from '../components'

const Page = () => {
    return <GetContent/>
};

export default Page;